import React from 'react';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { Shimmer } from '../../../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { TextLoading } from '../../../../../../CommonComponents/OPL/Text/Text.loading';
import PieChartImg from './img/PieChartImg.svg';

export const BucketLoading = () => {
  return (
    <Card p="16" height={712} display="flex" flexDirection="column">
      <TextLoading height="h3" width={86} mb="8" />

      <TextLoading height="h4" width="100%" mb="8" />
      <TextLoading height="h4" width="100%" mb="8" />
      <TextLoading height="h4" width={200} mb="8" />
      <TextLoading height="h4" width={180} mb="32" />

      <Box display="flex" alignItems="center" justifyContent="center" height={224} mb="8">
        <PieChartImg />
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        height="64"
        p="16"
        borderRadius="medium"
        border="1px solid"
        borderColor="neutral.300"
        mb={16}
      >
        <TextLoading height="h4" width={55} />

        <TextLoading height="h4" width={100} />
      </Box>

      <Shimmer height={56} mb="8" />
      <Box height={56} mb="8" />
      <Shimmer height={56} mb="32" />
    </Card>
  );
};
